import React from 'react';


export const VolumeOff = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063c-1.078 0.844-2.297 1.5-3.656 1.828v-2.063c0.844-0.234 1.594-0.656 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12c0-3.188-2.063-5.859-4.969-6.703v-2.063c4.031 0.891 6.984 4.5 6.984 8.766 0 1.5-0.375 2.953-1.031 4.172l-1.5-1.547c0.328-0.797 0.516-1.688 0.516-2.625zM16.5 12c0 0.234 0 0.422-0.047 0.609l-2.438-2.438v-2.203c1.5 0.75 2.484 2.25 2.484 4.031z" />
  </svg>);
